import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rw_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("rw_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, size, color, qty = 1, sku) => {
    const itemSku = sku || product.sku;
    const key = `${product.id}-${size}-${color}`;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i));
      return [...prev, {
        key, product_id: product.id, name: product.name, sku: itemSku,
        price: product.price, image: product.images?.[0] || "", size, color, qty,
      }];
    });
    toast.success(`${product.name} added to bag`);
    setOpen(true);
  };

  const updateQty = (key, qty) => {
    if (qty <= 0) return remove(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty } : i)));
  };
  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, updateQty, remove, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
